import React from "react";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Select from "react-select";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#505050",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class AssociateMedic extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    cat_medicos: [],
    medico: "",
    establecimiento: [],
    cat_establecimientos: [],
    cat_establecimientos_aux: [],
    lista_medico_asoc: [],
    asociacion_medico: {
      usuario_id: "",
      medico_nombre: "",
      establecimiento_id: "",
      nombre_establecimiento: "",
    },
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    // cargar catálogo con médicos veterinarios IPSA activos
    this.getMedicosVeterinariosIPSA();
    this.getEstablecimientoFNSOA();
  }

  /********* LLAMADAS A LA API ***********/

  getMedicosVeterinariosIPSA = () => {
    Api.loading(true);
    Api.fetch("app/getMedicosVeterinariosIPSA")
      .then((data) => {
        if (data) {
          this.setState({ cat_medicos: data });
        }
      })
      .then((data) => Api.loading(false));
  };

  getEstablecimientoFNSOA = () => {
    Api.loading(true);
    Api.fetch("app/getEstablecimientoFNSOA")
      .then((data) => {
        if (data) {
          this.setState({
            cat_establecimientos: data,
            cat_establecimientos_aux: data,
          });
        }
      })
      .then((data) => Api.loading(false));
  };

  /********** FUNCIONES PARA CONTROLAR EVENTOS **********/

  handleMedicoAsoc = (obj, evt) => {
    // limpamos errores si es que los hay
    let asociacion = this.state.asociacion_medico;

    this.cleanErrorsValidation(evt.name);

    switch (evt.name) {
      case "medico":
        if (obj) {
          this.getAsociacionesMedicoIPSA(obj.id);
          asociacion["usuario_id"] = obj.id;
          asociacion["medico_nombre"] = obj.medico_nombre;
          asociacion["establecimiento_id"] = "";
          asociacion["nombre_establecimiento"] = "";
          this.setState({ establecimiento: this.initialState.establecimiento });
        } else {
          asociacion["usuario_id"] = "";
          asociacion["medico_nombre"] = "";
          this.setState({
            lista_medico_asoc: this.initialState.lista_medico_asoc,
            cat_establecimientos: this.state.cat_establecimientos_aux,
          });
        }
        this.setState({ medico: obj, asociacion_medico: asociacion });
        break;
      case "establecimiento":
        if (obj) {
          asociacion["establecimiento_id"] = obj.id;
          asociacion["nombre_establecimiento"] = obj.razon_social;
        } else {
          asociacion["establecimiento_id"] = "";
          asociacion["nombre_establecimiento"] = "";
        }
        this.setState({ establecimiento: obj, asociacion_medico: asociacion });
        break;
      default:
        break;
    }
  };

  removerAsociacionMedico = (evt) => {
    Swal.fire({
      icon: "question",
      title: "Desasociar Médico Veterinario IPSA de establecimiento",
      text: "¿Desea continuar y desasociar médico veterinario IPSA a establecimiento?",
      showDenyButton: true,
      denyButtonColor: "red",
      confirmButtonColor: "#4CD964",
      showCancelButton: false,
      confirmButtonText: `Continuar`,
      denyButtonText: `Regresar`,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/removeAsociacionMedicoVeterinarioIPSA",
          {
            usuario_medico_id: evt.target.dataset.usr_id,
            establecimiento_id: evt.target.dataset.est_id,
          },
          "PUT"
        ).then((data) => {
          this.getAsociacionesMedicoIPSA(evt.target.dataset.usr_id, true);
          Api.loading(false);
          Swal.fire({
            icon: "success",
            title: "¡Se ha removido correctamente la asociación!",
            timer: 3000,
          });
        });
      }
    });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();

    let asociacion = this.state.asociacion_medico;

    if (asociacion.usuario_id === "") {
      this.handleValidations("medico");
    }

    if (asociacion.establecimiento_id === "") {
      this.handleValidations("establecimiento");
    }

    if (asociacion.usuario_id !== "" && asociacion.establecimiento_id !== "") {
      Swal.fire({
        icon: "question",
        title: "Asociar medico veterinario IPSA a establecimiento",
        text: "¿Desea continuar y asociar médico veterinario IPSA a establecimiento?",
        showDenyButton: true,
        denyButtonColor: "red",
        confirmButtonColor: "#4CD964",
        showCancelButton: false,
        confirmButtonText: `Continuar`,
        denyButtonText: `Regresar`,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitForm(asociacion);
        }
      });
    }
  };

  submitForm = (asociacion) => {
    Api.loading(true);
    Api.fetch(
      "app/storeAssociacionMedicoIPSAComercializador",
      asociacion,
      "POST"
    ).then((data) => {
      this.getAsociacionesMedicoIPSA(data.usuario_medico_id, true);
      Api.loading(false);
      Swal.fire({
        icon: "success",
        title: "¡Se ha guardado correctamente la asociación!",
        timer: 3000,
      });
    });
  };

  getAsociacionesMedicoIPSA = (usuario_medico_id, leer = false) => {
    Api.loading(true);
    Api.fetch(
      "app/getAsociacionesMedicoIPSA?usuario_medico_id=" + usuario_medico_id
    ).then((data) => {
      let listaMedicoAsoc = data,
        listaEstablecimientos = [],
        cat_establecimientos = this.state.cat_establecimientos_aux;

      listaEstablecimientos = data.map((obj) => obj.establecimiento.id);
      cat_establecimientos = cat_establecimientos.filter(
        (obj) => !listaEstablecimientos.includes(obj.id)
      );

      if (leer) {
        let rel = this.state.asociacion_medico;
        rel["establecimiento_id"] = "";
        rel["nombre_establecimiento"] = "";
        this.setState({
          asociacion_medico: rel,
          establecimiento: this.initialState.establecimiento,
        });
      }

      this.setState({
        lista_medico_asoc: listaMedicoAsoc,
        cat_establecimientos: cat_establecimientos,
      });
      Api.loading(false);
    });
  };

  // fn para marcar los campos que duevelen error desde la api
  handleValidations = (error) => {
    let textoError = "";

    error === "medico"
      ? (textoError = "Seleccione")
      : (textoError = "Seleccione.");

    document.getElementById(error + "-error").style.display = "block";
    document.getElementById(error + "-error").innerText = textoError;
    document.getElementById(error).classList.add("is-invalid");
  };

  // fn para desplegar mensajes de alerta sencillos
  fireSwal(title, icon = "error") {
    Swal.fire({
      title: title,
      icon: icon,
      timer: 3000,
    });
    return false;
  }

  // fn para reiniciar todos los estados una vez el submit sea éxitoso
  resetStates = () => {
    this.setState({
      cat_medicos: this.initialState.cat_medicos,
      medico: this.initialState.medico,
      establecimiento: this.initialState.establecimiento,
      cat_establecimientos: this.initialState.cat_establecimientos,
      asociacion_medico: this.initialState.asociacion_medico,
    });
  };

  /*********** Funciones ***********/

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation = (elemento) => {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item active">
            Asociar médico a establecimiento
          </li>
        </ol>

        <h1 className="page-header">Asociar médico a establecimiento</h1>

        <fieldset className="panel">
          <div className="row">
            <div className="col-lg-12">
              <fieldset>
                <form onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="medico">
                          Médico Veterinario IPSA:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="medico"
                          name="medico"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={true}
                          value={
                            this.state.medico !== null ||
                            this.state.medico !== ""
                              ? this.state.medico
                              : { label: "Seleccione", key: "0" }
                          }
                          onChange={this.handleMedicoAsoc}
                          theme="neutral40"
                          options={this.state.cat_medicos}
                          getOptionLabel={(medico) => medico.medico_nombre}
                          getOptionValue={(medico) => medico.id}
                          noOptionsMessage={() => "No se encontraron médicos"}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="medico-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-11">
                      <div className="form-group">
                        <label htmlFor="medico">
                          Razón Social: <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="establecimiento"
                          name="establecimiento"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={true}
                          value={
                            this.state.establecimiento !== null ||
                            this.state.establecimiento !== ""
                              ? this.state.establecimiento
                              : { label: "Seleccione", key: "0" }
                          }
                          onChange={this.handleMedicoAsoc}
                          theme="neutral40"
                          options={this.state.cat_establecimientos}
                          getOptionLabel={(establecimiento) =>
                            `${establecimiento.razon_social} (${establecimiento.folio_establecimiento})`
                          }
                          getOptionValue={(establecimiento) =>
                            establecimiento.id
                          }
                          noOptionsMessage={() =>
                            "No se encontraron establecimientos"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="establecimiento-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-1">
                      <div className="form-group">
                        <label htmlFor="associate-btn">&nbsp;</label>
                        <button
                          name="associate-btn"
                          title="Asociar médico"
                          onClick={this.handleSubmit}
                          type="button"
                          className="btn btn-block bg-gradient-blue"
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </fieldset>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <fieldset>
                <div id="listaMedicoAssoc">
                  <>
                    <table className="table table-striped m-b-0 table-hover">
                      <thead>
                        <tr>
                          <th>Razón Social</th>
                          <th>Fecha de asociación</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.lista_medico_asoc.length > 0 ? (
                          this.state.lista_medico_asoc.map((info, index) => (
                            <tr key={index} id={info.id}>
                              <td>{info.establecimiento.razon_social}</td>
                              <td>{info.fecha_asociacion}</td>
                              <td>
                                <button
                                  type="button"
                                  id={index}
                                  data-est_id={info.establecimiento.id}
                                  data-usr_id={info.usuario_medico_id}
                                  title="Remover asociación"
                                  onClick={this.removerAsociacionMedico}
                                  className="btn bg-gradient-red pull-right"
                                >
                                  <i
                                    id={index}
                                    data-est_id={info.establecimiento.id}
                                    data-usr_id={info.usuario_medico_id}
                                    onClick={this.removerAsociacionMedico}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center" colSpan="3">
                              No se encontraron registros
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <hr></hr>
                    <div className="row">
                      <div className="col-lg-12">
                        Todos los campos marcados con{" "}
                        <span className="text-danger">* </span> son
                        obligatorios.
                      </div>
                    </div>
                  </>
                </div>
              </fieldset>
            </div>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default AssociateMedic;
